:host{padding:8px}.header{display:flex;justify-content:space-between}.header-text{display:flex;flex-direction:column}.item-count{color:#232426de}.attribute-count{color:#23242699}
/*# sourceMappingURL=bulk-edit-view.component.css.map */
